import { inject, Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { InitParamsService } from './init-params.service';
import { catchError, map, Observable, of } from 'rxjs';
import { Utils } from '../utils/utils';
import { AddressService } from './address.service';
import { StoreConfig } from '../models/core/store-config.model';
import { Street } from '../models/core/street.model';
import { Address } from '../models/core/address.model';

@Injectable({
  providedIn: 'root',
})
export class AddressWrapperService extends AddressService {
  configService = inject(ConfigService);
  initParams = inject(InitParamsService);

  extractAddressAttributesFromParams(): Observable<any> {
    const fromParams = this.initAddressFromParams();

    if (
      !Utils.isNullOrUndefined(this.initParams.lat) &&
      !Utils.isNullOrUndefined(this.initParams.lng) &&
      this.configService.configState().store?.useBuildingsInWeb
    ) {
      return of(fromParams);
    } else if (this.initParams.address) {
      return this.initAddressFromMatches(
        this.initParams.address,
        this.initParams.zip ?? '',
        this.configService.configState().store!
      ).pipe(map((r) => ({ ...fromParams, ...r })));
    } else {
      return of(this.getOtherAddressParams());
    }
  }

  private getOtherAddressParams() {
    const addressParams: Partial<Address> = {
      addressType: this.initParams.addressType ?? undefined,
      zip: this.initParams.zip ?? undefined,
      diff1: this.initParams.diff1 ?? undefined,
      diff2: this.initParams.diff2 ?? undefined, 
      diff3: this.initParams.diff3 ?? undefined,
      name: this.initParams.addressName ?? undefined,
      deliveryInstructions: this.initParams.deliveryInstructions ?? undefined,
    };
    return addressParams;
  }

  private initAddressFromParams(): any {
    return {
      street: this.initParams.address ?? undefined,
      addressType: this.initParams.addressType ?? undefined,
      name: this.initParams.addressName ?? undefined,
      value1: this.initParams.diff1 ?? undefined,
      value2: this.initParams.diff2 ?? undefined,
      value3: this.initParams.diff3 ?? undefined,
      lng: this.initParams.lng ?? undefined,
      lat: this.initParams.lat ?? undefined,
      zip: this.initParams.zip ?? undefined,
      deliveryInstructions: this.initParams.deliveryInstructions ?? undefined,
    };
  }

  private initAddressFromMatches(
    address: string,
    zip: string,
    storeConfig: StoreConfig
  ): Observable<any> {
    return this.getStreetMatches(address, storeConfig.useBuildingsInWeb).pipe(
      catchError(() => of([])),
      map((matchedStreets) => matchedStreets.find(
          (matchedStreet: Street) =>
            !matchedStreet.partialMatch &&
            (zip ? matchedStreet.zip === zip : true) 

      ) || {
        address: address,
        zip: zip
      } as Street),
      map((matchedStreet: Street) => {
        return matchedStreet
          ? {
              street: matchedStreet.address,
              city: matchedStreet.city,
              state: matchedStreet.state,
              zip: matchedStreet.zip,
              buildingName: matchedStreet.buildingName,
            }
          : {};
      })
    );
  }
}
